import { render } from "./ToggleFavouritedButton.vue?vue&type=template&id=ef5f6594&scoped=true"
import script from "./ToggleFavouritedButton.vue?vue&type=script&lang=js"
export * from "./ToggleFavouritedButton.vue?vue&type=script&lang=js"

import "./ToggleFavouritedButton.vue?vue&type=style&index=0&id=ef5f6594&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef5f6594"]])

export default __exports__